<td tabindex="0" [attr.data-image-id]="image.id" [@focusedTrigger]="active" class="cm-grid-cell">
    <div class="image" [ngStyle]="{'background-image': 'url(' + image.large_url + ')'}"></div>
</td>
